import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lab-nav-tabs',
  templateUrl: './lab-nav-tabs.component.html',
  styleUrls: ['./lab-nav-tabs.component.scss']
})
export class LabNavTabsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
